import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useDebounce } from 'react-use';
const useDebouncedValue = (value, t0) => {
  const $ = _c(4);
  const delay = t0 === undefined ? 2000 : t0;
  const [debouncedValue, setDebouncedValue] = useState(null);
  let t1;
  if ($[0] !== value) {
    t1 = () => {
      setDebouncedValue(value);
    };
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = [value];
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useDebounce(t1, delay, t2);
  return debouncedValue;
};
export default useDebouncedValue;